<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="8" class="text-center">
        <div class="mb-6">
          <v-icon color="primary" size="72">mdi-play-circle-outline</v-icon>
        </div>
        
        <h1 class="text-h3 font-weight-bold text-primary mb-4">
          Free Demo Assessment
        </h1>
        
        <p class="text-h6 text-medium-emphasis mb-6">
          Experience how simple and supportive our assessment platform is for your family.
        </p>
        
        <v-card class="pa-6 mb-6">
          <h2 class="text-h5 font-weight-bold mb-4">What You'll Experience:</h2>
          
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>Age-appropriate questions</span>
              </div>
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>Child-friendly interface</span>
              </div>
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>Immediate, supportive feedback</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>Professional report sample</span>
              </div>
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>No personal data required</span>
              </div>
              <div class="d-flex align-center mb-4">
                <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
                <span>Complete privacy protection</span>
              </div>
            </v-col>
          </v-row>
        </v-card>
        
        <div class="d-flex justify-center ga-4 flex-wrap mb-6">
          <v-btn
            color="primary"
            size="large"
            variant="flat"
            class="px-8"
            to="/assessments"
          >
            <v-icon start>mdi-play</v-icon>
            Start Demo Assessment
          </v-btn>
          
          <v-btn
            color="secondary"
            size="large"
            variant="outlined"
            class="px-6"
            to="/"
          >
            <v-icon start>mdi-arrow-left</v-icon>
            Back to Home
          </v-btn>
        </div>
        
        <v-alert
          type="info"
          variant="tonal"
          class="text-left"
        >
          <strong>Note:</strong> This demo assessment is completely anonymous and doesn't require any personal information. 
          It's designed to show you exactly how our platform works and how comfortable your child will be during the real assessment.
        </v-alert>
        
        <div class="mt-6">
          <p class="text-body-2 text-medium-emphasis">
            Questions about the demo? 
            <nuxt-link to="/contact" class="text-primary">Contact our support team</nuxt-link> - we're here to help!
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">

// SEO
useHead({
  title: 'Free Demo Assessment - INDA Platform',
  meta: [
    {
      name: 'description',
      content: 'Try our free demo assessment to see how simple and supportive the INDA platform is for South African homeschool families. No personal data required.'
    }
  ]
});
</script>